import { MetaMessageTemplate } from "../../../../../model/integration/dto/meta/MetaMessageTemplate";
import { WhatsappCampaignParameter } from "../../../../../model/integration/types/whatsapp/WhatsappCampaignParameter";
import { WhatsappCampaignParameterSource } from "../../../../../model/integration/types/whatsapp/WhatsappCampaignParameterSource.enum";
import { WhatsappCampaignTemplateParameters } from "../../../../../model/integration/types/whatsapp/WhatsappCampaignTemplateParameters";
import {
  TemplateVariable,
  templateParametersFrom,
  templateValuesFrom,
} from "../../whatsapp-chat/utils/templateVariables";

/** Only text placeholders can be filled from the contact */
export const canUseContactName = (variable: TemplateVariable) =>
  variable.area === "header" || variable.area === "body";

/** The send modal's values, plus which placeholders take the contact's name.
 * Those keep their typed value as the fallback for someone with no name.
 */
export const campaignParametersFrom = (
  variables: TemplateVariable[],
  values: Record<string, string>,
  fromContact: string[],
): WhatsappCampaignTemplateParameters | undefined => {
  const base = templateParametersFrom(variables, values);

  if (!base) {
    return undefined;
  }

  const withSource = (
    area: "header" | "body",
    list?: { name: string; value: string }[],
  ): WhatsappCampaignParameter[] | undefined =>
    list?.map(({ name, value }) => ({
      name,
      value,
      source: fromContact.includes(`${area}:${name}`)
        ? WhatsappCampaignParameterSource.CONTACT_NAME
        : WhatsappCampaignParameterSource.FIXED,
    }));

  return {
    header: withSource("header", base.header),
    body: withSource("body", base.body),
    buttons: base.buttons,
    location: base.location,
  };
};

/** The other way round, to edit a saved campaign */
export const campaignValuesFrom = (
  template?: MetaMessageTemplate,
  parameters?: WhatsappCampaignTemplateParameters,
) => {
  const fromContact = (["header", "body"] as const).flatMap((area) =>
    (parameters?.[area] || [])
      .filter(
        ({ source }) => source === WhatsappCampaignParameterSource.CONTACT_NAME,
      )
      .map(({ name }) => `${area}:${name}`),
  );

  return { values: templateValuesFrom(template, parameters), fromContact };
};
